import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NetworkUtilsService, URL_DICT } from 'projects/app-core/src/service/network-utils.service';

export interface ICreateOrUpdateRuleEngine {
  id?: string;
  name: string;
  priority: number;
  conditions: Record<string, unknown>;
  active: boolean;
  event: Record<string, unknown>;
  type: string;
}

export enum RuleType {
  CIRCLE_RULES = 'CIRCLE_RULES',
  EVENT_RULES = 'EVENT_RULES',
  THERAPIST_EXPERT_LEVELS = 'THERAPIST_EXPERT_LEVELS',
  THERAPY_PLANS_RULES = 'THERAPY_PLANS_RULES',
  LYFIS_QUESTIONNAIRE_RULES = 'LYFIS_QUESTIONNAIRE_RULES',
  LYFIS_LAB_MARKER_SCORING_RULES = 'LYFIS_LAB_MARKER_SCORING_RULES',
  LYFIS_PDH_BANDS_RULES = 'LYFIS_PDH_BANDS_RULES',
  LYFIS_GHS_BANDS_RULES = 'LYFIS_GHS_BANDS_RULES',
  LYFIS_DRS_WEIGHTING_RULES = 'LYFIS_DRS_WEIGHTING_RULES',
  LYFIS_LAB_FRESHNESS_BANDS_RULES = 'LYFIS_LAB_FRESHNESS_BANDS_RULES',
}

export interface RulesGridRequest {
  page: number;
  pageSize: number;
  export?: boolean;
  sort?: { PRIORITY?: 'ASC' | 'DESC' };
  filters?: { TYPE?: RuleType[]; ACTIVE?: string[] };
  searchQuery?: { NAME?: string };
  globalSearch?: string[];
}

export interface RulesGridItem {
  id: string;
  name: string;
  priority: number;
  active: boolean;
  event: { type: string; params: string[] };
  type: RuleType;
}

export interface RulesGridResponse {
  filterOptions?: unknown;
  data: RulesGridItem[];
  pageNum: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

@Injectable({ providedIn: 'root' })
export class RuleEngineService {

  constructor(private api: NetworkUtilsService
  ) {}

  getRule(id: string): Observable<ICreateOrUpdateRuleEngine> {
    return this.api.get<ICreateOrUpdateRuleEngine>(URL_DICT.adminRuleEngineGetUrl + id);
  }

  createOrUpdate(rule: ICreateOrUpdateRuleEngine): Observable<{ id: string }> {
    return this.api.post<{ id: string }>(URL_DICT.adminRuleEngineCreateUrl, rule);
  }

  getRulesGrid(req: RulesGridRequest): Observable<RulesGridResponse> {
    return this.api.post<RulesGridResponse>(URL_DICT.adminRuleEngineGridUrl, req);
  }
}


